module.exports = __webpack_public_path__ + "img/thumb_20.41e21061.jpg";